import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TouchableOpacity } from "react-native";
import { Icon } from "../Icon";
import { Small, Text } from "../Text";
import { View } from "../View";
import { useTheme } from "../../styles";
function TabHeader(param) {
    var text = param.text, icon = param.icon, count = param.count, active = param.active, style = param.style, onPress = param.onPress, testID = param.testID, disabled = param.disabled;
    var theme = useTheme().theme;
    var color = active ? theme.color.primary100 : theme.color.gray300;
    return /*#__PURE__*/ _jsx(TouchableOpacity, {
        disabled: disabled,
        style: [
            style,
            {
                alignItems: 'center'
            }
        ],
        onPress: onPress,
        testID: testID,
        role: "tab",
        "aria-selected": active,
        "aria-disabled": disabled,
        children: /*#__PURE__*/ _jsxs(View, {
            row: true,
            style: [
                {
                    borderColor: 'transparent',
                    borderBottomWidth: 2,
                    paddingBottom: 10,
                    justifyContent: 'flex-end',
                    opacity: disabled ? 0.5 : undefined
                },
                active ? {
                    borderColor: theme.color.primary100
                } : null
            ],
            spacing: 12,
            children: [
                icon ? /*#__PURE__*/ _jsx(Icon, {
                    name: icon,
                    color: color
                }) : null,
                /*#__PURE__*/ _jsx(Text, {
                    text: text,
                    weight: "semibold",
                    color: color,
                    size: 15
                }),
                typeof count === 'number' ? /*#__PURE__*/ _jsx(View, {
                    style: {
                        borderRadius: 30,
                        backgroundColor: active ? '#F7EEEF' : theme.color.gray700,
                        paddingVertical: 1,
                        paddingHorizontal: 10
                    },
                    children: /*#__PURE__*/ _jsx(Small, {
                        color: color,
                        text: count.toString()
                    })
                }) : null
            ]
        })
    });
}
/**
 * Displays a row of tab headers to the user. Tapping on a tab calls
 * `onChangeValue` with the selected tab.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-136}
 */ export function Tabs(param) {
    var activeTab = param.value, setActiveTab = param.onChangeValue, style = param.style, items = param.items, itemStyle = param.itemStyle, testID = param.testID, topOfRoundedSection = param.topOfRoundedSection;
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(View, {
        testID: testID,
        row: true,
        style: [
            {
                borderBottomWidth: 1,
                borderColor: theme.color.gray600
            },
            topOfRoundedSection ? {
                borderTopStartRadius: 30,
                borderTopEndRadius: 30,
                paddingTop: 10,
                marginTop: -15,
                backgroundColor: 'white',
                marginHorizontal: -20,
                marginBottom: 20
            } : null,
            style
        ],
        children: items.map(function(item) {
            return /*#__PURE__*/ _jsx(TabHeader, {
                text: item.text,
                icon: item.icon,
                count: item.count,
                active: activeTab === item.value,
                onPress: function() {
                    return setActiveTab(item.value);
                },
                testID: testID ? "".concat(testID, "_").concat(item.value) : undefined,
                disabled: item.disabled,
                style: [
                    {
                        flex: 1
                    },
                    itemStyle
                ]
            }, item.value);
        })
    });
}
